import React, { useState } from 'react'
import Loading from '../components/Loading'
import FormContextWrapper from './FormContextWrapper'

const FormContext = React.createContext(null)

const FormContextProvider = ({ children }) => {
  const [authData, setAuthData] = useState(null)
  const [questionData, setQuestionData] = useState(null)
  const [clear, setClear] = useState(false)
  const [loading, setLoading] = useState(false)

  const setQuestionWrapper = (data, animation) => {
    data.animation = animation

    setClear(true)
    setQuestionData(data)
  }

  const value = {
    authData,
    setAuthData,
    questionData,
    setQuestionData: setQuestionWrapper,
    clear,
    setClear,
    loading,
    setLoading
  }

  return (
    <FormContext.Provider value={value}>
      <FormContextWrapper>
        {loading && <Loading />}
        {children}
      </FormContextWrapper>
    </FormContext.Provider>
  )
}

export {
  FormContextProvider,
  FormContext
}
